module.exports = __webpack_public_path__ + "static/kassenlotse.c8209613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kassenlotse/kassenlotse.jpg
// module id = 760
// module chunks = 102538987983895